import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import type { AppDispatch } from "./types";
import { RootState } from "../state";

export const useAppDispatch = useDispatch as () => AppDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;